import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable, of} from 'rxjs';

@Injectable()
export class AddressService {
  private resourceUrl = environment.apiUrl + 'office';

  constructor(private http: HttpClient) {
  }

  getAllOffices(mock?: boolean): Observable<any[]> {
    if (mock) {
      return of(this.getAllProjectsMock());
    }
    return this.http.get<any[]>(this.resourceUrl + '/list');
  }

  getOffice(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id);
  }

  getOfficeHeader(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id + '/header/');
  }

  save(request: any): Observable<any> {
    return this.http.post<any>(this.resourceUrl, request);
  }

  delete( id: number): Observable<any> {
    return this.http.delete<any>(this.resourceUrl + '/' + id, {});
  }

  getCityList(request: any): Observable<any[]> {
    return this.http.post<any[]>(environment.apiUrl + 'location/autocomplete', request);
  }

  private getAllProjectsMock() {
    return [
      {
        id: 1,
        name: 'Project 1',
        type: 'The cage',
      },
  ]};
}
